/* Ellips product page (sections/el-pdp.liquid), store rebuild 2026-09-24.
   The page sells without this file: the Starter switch is a real checkbox named selling_plan inside a real /cart/add
   form, and CSS (:has) shows the copy for its state. This file adds: the add to cart through window.ElCart (the cart
   drawer, assets/el-cart.js), the gallery (arrows, thumbnails, keys), the ingredients dialog, the sticky bar on
   desktop, the sticky gallery offset, and the email-code check against the cart. */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const desktop = window.matchMedia('(min-width: 990px)');
  const onMedia = (mq, fn) => (mq.addEventListener ? mq.addEventListener('change', fn) : mq.addListener(fn));
  const url = (path) => (window.ellipsUrl ? window.ellipsUrl(path) : '/' + path);

  /* Starter switch: mirror the checkbox on the root (older browsers without :has use it; the cart builder and
     analytics can read it too). pageshow covers a page restored from the back-forward cache with the box unticked. */
  function initPlan(root) {
    const sw = $('[data-el-pd-switch]', root);
    if (!sw) return;
    const sync = () => root.setAttribute('data-plan', sw.checked ? 'on' : 'off');
    sw.addEventListener('change', sync);
    window.addEventListener('pageshow', sync);
    sync();
  }

  /* Size + purchase-option box (2026-10-01): the radios sit outside the form. Copy the choice into the form's variant
     and selling_plan inputs and into the root's data-tb ("try-once" | "try-sub" | "jar-once" | "jar-sub") and
     data-tb-freq ("2" | "3" | "6"), which the CSS uses to show the matching prices and words. A blank plan id (the new
     plans don't exist yet) sends the line one-time. */
  function initTb(root) {
    const tb = $('[data-el-tb]', root);
    const form = $('[data-el-pd-form]', root);
    if (!tb || !form) return;
    const vIn = $('[data-el-pd-variant]', form);
    const pIn = $('[data-el-pd-plan-input]', form);
    const freqs = ['2', '3', '6'];
    const plans = { try: (tb.dataset.plansTry || '').split(','), jar: (tb.dataset.plansJar || '').split(',') };
    const variants = { try: tb.dataset.variantTry, jar: tb.dataset.variantJar };
    const avail = { try: tb.dataset.availTry === '1', jar: tb.dataset.availJar === '1' };
    const hasSub = { try: tb.dataset.subTry === '1', jar: tb.dataset.subJar === '1' };
    const subOpt = $('.el-tb__opt--sub', tb);
    const onceIn = $('[data-el-tb-plan][value="once"]', tb);
    const picked = (sel, dflt) => { const c = $(sel + ':checked', tb); return c ? c.value : dflt; };
    const sync = () => {
      const size = picked('[data-el-tb-size]', 'try');
      if (subOpt) subOpt.hidden = !hasSub[size];
      if (!hasSub[size] && onceIn && !onceIn.checked) onceIn.checked = true;
      const plan = picked('[data-el-tb-plan]', 'once');
      const freq = picked('[data-el-tb-freq]', '3');
      root.setAttribute('data-tb', size + '-' + plan);
      root.setAttribute('data-tb-freq', freq);
      if (vIn) vIn.value = variants[size];
      const id = plan === 'sub' ? String(plans[size][freqs.indexOf(freq)] || '').trim() : '';
      if (pIn) { pIn.value = id; pIn.disabled = !id; }
      $$('button[type="submit"]').filter((b) => b.form === form).forEach((b) => { b.disabled = !avail[size]; });
      try { document.dispatchEvent(new CustomEvent('el:buybox', { detail: { size, plan, freq } })); } catch (e) { /* old browser */ }
    };
    tb.addEventListener('change', sync);
    window.addEventListener('pageshow', sync);
    sync();
  }

  /* Add to cart: hand the line to the cart drawer. Without ElCart the browser posts the form to /cart/add. */
  function initForm(root) {
    const form = $('[data-el-pd-form]', root);
    if (!form) return;
    const buttons = () => $$('button[type="submit"]').filter((b) => b.form === form);
    form.addEventListener('submit', (event) => {
      const cart = window.ElCart;
      if (!cart || typeof cart.add !== 'function') return;
      event.preventDefault();
      if (root.classList.contains('is-busy')) return;
      const variant = $('[data-el-pd-variant]', form);
      const item = { id: Number(variant && variant.value), quantity: 1 };
      const sw = $('[data-el-pd-switch]', form);
      if (sw && sw.checked && sw.value) item.selling_plan = Number(sw.value);
      const pin = $('[data-el-pd-plan-input]', form);
      if (pin && !pin.disabled && pin.value) item.selling_plan = Number(pin.value);
      root.classList.add('is-busy');
      buttons().forEach((b) => b.setAttribute('aria-busy', 'true'));
      let done;
      try { done = Promise.resolve(cart.add([item])); } catch (err) { done = Promise.reject(err); }
      done.catch(() => {}).then(() => {
        root.classList.remove('is-busy');
        buttons().forEach((b) => b.removeAttribute('aria-busy'));
      });
    });
  }

  /* Gallery analytics: a document event that snippets/el-posthog forwards (gallery_slide_viewed, gallery_zoom_opened,
     gallery_finder_clicked). No personal data. */
  const announce = (detail) => { try { document.dispatchEvent(new CustomEvent('el:gallery', { detail })); } catch (e) { /* old browser */ } };

  /* Gallery: one scroll-snap track (swipe is native), arrows, thumbnails and arrow keys move it. */
  function initGallery(root) {
    const gallery = $('[data-el-pd-gallery]', root);
    const track = gallery && $('[data-el-pd-track]', gallery);
    if (!track) return;
    const slides = $$('[data-el-pd-slide]', track);
    const thumbs = $$('[data-el-pd-thumb]', gallery);
    const prev = $('[data-el-pd-prev]', gallery);
    const next = $('[data-el-pd-next]', gallery);
    const count = $('[data-el-pd-count]', gallery);
    const last = slides.length - 1;
    let index = 0;
    const at = () => Math.max(0, Math.min(last, Math.round(track.scrollLeft / (track.clientWidth || 1))));
    const paint = () => {
      index = at();
      thumbs.forEach((t, k) => {
        if (k === index) {
          t.setAttribute('aria-current', 'true');
          const strip = t.parentElement;
          if (strip && strip.scrollWidth > strip.clientWidth) {
            const left = t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
            strip.scrollTo({ left: Math.max(0, left), behavior: reduced() ? 'auto' : 'smooth' });
          }
        } else {
          t.removeAttribute('aria-current');
        }
      });
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= last;
      if (count) count.textContent = (index + 1) + ' / ' + slides.length;
      if (slides[index]) gallery.setAttribute('data-kind', slides[index].getAttribute('data-el-pd-kind') || '');
      if (slides[index]) announce({ action: 'slide', index: index + 1, kind: slides[index].getAttribute('data-el-pd-kind') || '' });
    };
    const go = (i) => {
      const k = Math.max(0, Math.min(last, i));
      track.scrollTo({ left: slides[k].offsetLeft, behavior: reduced() ? 'auto' : 'smooth' });
    };
    let frame = 0;
    track.addEventListener('scroll', () => {
      if (!frame) frame = requestAnimationFrame(() => { frame = 0; if (at() !== index) paint(); });
    }, { passive: true });
    if (prev) prev.addEventListener('click', () => go(index - 1));
    if (next) next.addEventListener('click', () => go(index + 1));
    thumbs.forEach((t, k) => t.addEventListener('click', (event) => { event.preventDefault(); go(k); }));
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(index - 1); }
      else if (event.key === 'ArrowRight') { event.preventDefault(); go(index + 1); }
    });
    window.addEventListener('resize', () => { track.scrollLeft = slides[index] ? slides[index].offsetLeft : 0; }, { passive: true });
    gallery.classList.add('is-ready');
    paint();
    initLoops(track);
    initZoom(root, track);
  }

  /* The how-to photo's drip loop (gallery rebuild 2026-09-29): muted, plays only while at least half of it is on
     screen, never with reduced motion (the poster frame stays). */
  function initLoops(track) {
    const vids = $$('.el-gx__vid', track);
    if (!vids.length) return;
    vids.forEach((v) => { v.muted = true; v.loop = true; v.playsInline = true; v.removeAttribute('controls'); });
    if (reduced() || !('IntersectionObserver' in window)) {
      vids.forEach((v) => { v.removeAttribute('autoplay'); v.pause(); });
      return;
    }
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting && e.intersectionRatio >= 0.5) {
        v.preload = 'auto';
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      } else {
        v.pause();
      }
    }), { threshold: [0, 0.5, 1] });
    vids.forEach((v) => io.observe(v));
  }

  /* Photo zoom: tap a gallery photo to open it full screen, tap the photo to magnify it where you tapped. Links on a
     photo (the formula finder) keep working. */
  function initZoom(root, track) {
    const zoomer = $('[data-el-pd-zoomer]', root);
    if (!zoomer || typeof zoomer.showModal !== 'function') return;
    const img = $('[data-el-pd-zoom-img]', zoomer);
    const pane = $('[data-el-pd-zoom-pane]', zoomer);
    track.addEventListener('click', (event) => {
      const fl = event.target.closest('a.el-gx__fl');
      if (fl) { announce({ action: 'finder', to: (fl.getAttribute('href') || '').split('?')[0].split('/').pop() }); return; }
      if (event.target.closest('a, button')) return;
      const slide = event.target.closest('[data-el-pd-zoom]');
      if (!slide) return;
      const base = $('img', slide);
      img.src = slide.getAttribute('data-el-pd-zoom');
      img.alt = base ? base.alt : '';
      zoomer.classList.remove('is-zoomed');
      zoomer.showModal();
      announce({ action: 'zoom', index: $$('[data-el-pd-slide]', track).indexOf(slide) + 1, kind: slide.getAttribute('data-el-pd-kind') || '' });
    });
    img.addEventListener('click', (event) => {
      const r = img.getBoundingClientRect();
      const fx = (event.clientX - r.left) / (r.width || 1);
      const fy = (event.clientY - r.top) / (r.height || 1);
      zoomer.classList.toggle('is-zoomed');
      if (zoomer.classList.contains('is-zoomed')) {
        requestAnimationFrame(() => {
          pane.scrollLeft = fx * pane.scrollWidth - pane.clientWidth / 2;
          pane.scrollTop = fy * pane.scrollHeight - pane.clientHeight / 2;
        });
      }
    });
    $('[data-el-pd-zoom-close]', zoomer).addEventListener('click', () => zoomer.close());
    zoomer.addEventListener('click', (event) => { if (event.target === zoomer) zoomer.close(); });
  }

  /* The desktop gallery column is sticky. When it is taller than the window, pin it by its bottom edge instead of
     its top, so the ingredient callouts under it stay reachable. */
  function initStickyGallery(root) {
    const gallery = $('[data-el-pd-gallery]', root);
    if (!gallery) return;
    const fit = () => {
      gallery.style.removeProperty('--el-pd-top');
      if (!desktop.matches) return;
      const wanted = parseFloat(getComputedStyle(gallery).top) || 0;
      const room = window.innerHeight - gallery.offsetHeight - 24;
      if (room < wanted) gallery.style.setProperty('--el-pd-top', Math.round(room) + 'px');
    };
    fit();
    window.addEventListener('load', fit);
    window.addEventListener('resize', fit, { passive: true });
    onMedia(desktop, fit);
  }

  /* Ingredients dialog: native <dialog>; closes with Esc, the close button or a click on the backdrop. */
  function initDialog(root) {
    const dialog = $('[data-el-pd-dialog]', root);
    if (!dialog) return;
    const html = document.documentElement;
    const open = () => {
      if (typeof dialog.showModal === 'function') { if (!dialog.open) dialog.showModal(); } else dialog.setAttribute('open', '');
      html.classList.add('el-pd-lock');
    };
    const close = () => {
      if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
      html.classList.remove('el-pd-lock');
    };
    dialog.addEventListener('close', () => html.classList.remove('el-pd-lock'));
    $$('[data-el-pd-dialog-open]', root).forEach((b) => b.addEventListener('click', open));
    $$('[data-el-pd-dialog-close]', dialog).forEach((b) => b.addEventListener('click', close));
    dialog.addEventListener('click', (event) => { if (event.target === dialog) close(); });
  }

  /* Sticky add-to-cart, hidden until it has something to add: on phones it slides in once the "What one capsule does"
     section (.el-benefits) reaches the window, and hides again above it (owner, 2026-09-25); on desktop, and on pages
     without that section, once the buy box's own button has scrolled above the window. */
  function initSticky(root) {
    const bar = $('[data-el-pd-sticky]', root);
    const atc = $('[data-el-pd-atc]', root);
    if (!bar || !atc) return;
    const phone = window.matchMedia('(max-width: 989px)');
    const benefits = $('.el-benefits');
    const seen = new Map();
    const apply = () => {
      const target = phone.matches && benefits ? benefits : atc;
      bar.classList.toggle('is-visible', Boolean(seen.get(target)));
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const top = entry.boundingClientRect.top;
          seen.set(entry.target, entry.target === atc ? !entry.isIntersecting && top < 0 : entry.isIntersecting || top < 0);
        });
        apply();
      });
      io.observe(atc);
      if (benefits) io.observe(benefits);
      onMedia(phone, apply);
    } else {
      bar.classList.add('is-visible');
    }
  }

  /* Email pages: the inline check already showed the bubble when the discount_code cookie holds this page's code.
     Shopify also keeps codes on the cart, so look there (and after every cart change) before settling. */
  function initCode(root) {
    const box = $('[data-el-pd-code]', root);
    if (!box) return;
    const want = String(box.getAttribute('data-el-pd-code') || '').toUpperCase();
    if (!want) return;
    const check = (cart) => {
      if (!cart || !box.hidden) return;
      if ((cart.discount_codes || []).some((d) => String(d.code || '').toUpperCase() === want)) {
        box.hidden = false;
        root.classList.add('is-code');
      }
    };
    if (box.hidden) {
      fetch(url('cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then((r) => (r.ok ? r.json() : null))
        .then(check)
        .catch(() => {});
    }
    document.addEventListener('el:cart:changed', (event) => check(event.detail));
  }

  function init() {
    $$('[data-el-pd]').forEach((root) => {
      if (root.dataset.elPdReady) return;
      root.dataset.elPdReady = '1';
      initPlan(root);
      initTb(root);
      initForm(root);
      initGallery(root);
      initStickyGallery(root);
      initDialog(root);
      initSticky(root);
      initCode(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
